import { render, staticRenderFns } from "./customerStatistic.vue?vue&type=template&id=fdaa3446&scoped=true"
import script from "./customerStatistic.vue?vue&type=script&lang=js"
export * from "./customerStatistic.vue?vue&type=script&lang=js"
import style0 from "./customerStatistic.vue?vue&type=style&index=0&id=fdaa3446&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdaa3446",
  null
  
)

export default component.exports